import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from 'vue'
import Card from '@/views/dashboard/_components/card/card.vue'
import AlertTrendCard from './alert-trend-card.vue'
import ThreatDistributionCard from './threat-distribution-card.vue'
import RealtimeVirusAlertPanel from './realtime-virus-alert-panel.vue'
import RealtimeRiskTerminalRanking from './realtime-risk-terminal-ranking.vue'
import { TimeRange } from '@/views/dashboard/_components/time-range-select/time-range.enum'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'


export default /*#__PURE__*/_defineComponent({
  __name: 'realtime-monitoring',
  setup(__props) {

const timeRange = ref<TimeRange>(TimeRange.DAYS_30)

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(Card, {
    size: "first",
    border: "",
    title: _ctx.$t('overviewZone.realtimeZoneTitle'),
    description: _ctx.$t('overviewZone.realtimeZoneDesc'),
    class: "realtime-monitoring-wrap",
    "background-color": "var(--cm-color-card-bg)"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, { gutter: 16 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 16 }, {
            default: _withCtx(() => [
              _createVNode(AlertTrendCard, {
                "time-range": timeRange.value,
                "onUpdate:timeRange": _cache[0] || (_cache[0] = ($event: any) => ((timeRange).value = $event))
              }, null, 8, ["time-range"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withCtx(() => [
              _createVNode(ThreatDistributionCard)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, {
        gutter: 16,
        class: "realtime-monitoring-lower"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            span: _unref(IS_JP_ONLY_BUILD)?24:16,
            class: "realtime-monitoring-lower__col"
          }, {
            default: _withCtx(() => [
              _createVNode(RealtimeVirusAlertPanel)
            ]),
            _: 1
          }, 8, ["span"]),
          (!_unref(IS_JP_ONLY_BUILD))
            ? (_openBlock(), _createBlock(_component_el_col, {
                key: 0,
                span: 8,
                class: "realtime-monitoring-lower__col"
              }, {
                default: _withCtx(() => [
                  _createVNode(RealtimeRiskTerminalRanking)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "description"]))
}
}

})